// import './pusher.min.js';
import "./login.css";
import "react-toastify/dist/ReactToastify.css";

import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";

import { LoginService } from "../adapter/adminAdapter";

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="right" {...props}>
      {"Copyright © "}
      <Link color="inherit" href="https://presolv360.com/">
        PRESOLV360
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
const theme = createTheme({ palette: { primary: { main: "#005186" } } });
const SignIn = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const [errorms, setErrorms] = useState("");
   React.useEffect(()=>{
     if(localStorage.getItem('userId')){
       navigate('/app/home')
         return
     }
   },[])
   function handleSubmit (event) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
     if(data.get('email')==="" || data.get('password')==="" ){
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Email and Password Mandatory for login",
        showConfirmButton: false,
        timer: 1500
      });
      return
     }

LoginService.login({email: data.get("email"),
password: data.get("password")})
.then((result)=>{
    if(result.status === 200){
localStorage.setItem('userEmail',result.data.data.email)
localStorage.setItem('userId',result.data.data.id)
localStorage.setItem("userIn", JSON.stringify(result.data.data));
localStorage.setItem('token', result.data.data.token);
localStorage.setItem('login',true)
 navigate('/app/home')
    }
    else {
      setErrorms(result.statusText);
      Swal.fire({
        position: "center",
        icon: "error",
        title: result.message,
        showConfirmButton: false,
        timer: 1500
      });
    }
  })
  .catch((err)=>{
    Swal.fire({
      position: "center",
      icon: "error",
      title: err.message,
      showConfirmButton: false,
      timer: 1500
    });
  })
  };
  return (
    <ThemeProvider theme={theme}>
      
      <div className="flex-container">
        <div className="login-rightform">
       
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              
              <div className="logoDiv">
                <img src="../../img/logo.png" alt="" className="logoImg" />
              </div>
              <div className="LoginDivText">
                <p className="LoginText">Login to manage your account</p>
              </div>

              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                {/* <ToastContainer /> */}
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  type="email"
                  label="Email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  size="small"
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  size="small"
                />
                <p className="errorms">{errorms}</p>
                <Button
                  color="primary"
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Login
                </Button>
                <div className="LoginBottom-container">
                  <div className="Signup-div">
                  </div>
                  <Copyright />
                </div>
              </Box>
            </Box>
          </Container>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default SignIn;
